module.exports = __webpack_public_path__ + "img/vid-poster.628756e.jpeg";